export default "__VITE_ASSET__CXR8unZQ__"